import { render } from "./UnshareAll.vue?vue&type=template&id=e8ce5da6&scoped=true"
import script from "./UnshareAll.vue?vue&type=script&lang=js"
export * from "./UnshareAll.vue?vue&type=script&lang=js"

import "./UnshareAll.vue?vue&type=style&index=0&id=e8ce5da6&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ce5da6"]])

export default __exports__